import React from 'react';
import { Box, Typography } from '@mui/material';
import { IoNewspaper } from 'react-icons/io5';
import {
  CoachmarkCanvas,
  HighlightFrame,
  SkeletonBar,
  SkeletonBlock,
} from '../../../../components/field-coachmark/CoachmarkSkeleton';
import type { CoachmarkState } from '../../../../components/field-coachmark/FieldCoachmark';

const TypeDocumentsIcon = () => <IoNewspaper style={{ fontSize: 11, display: 'block' }} />;

const BaseActions = () => (
  <>
    <SkeletonBlock width={9} height={9} radius={2} />
    <SkeletonBlock width={9} height={9} radius={2} />
    <SkeletonBlock width={9} height={9} radius={2} />
  </>
);

const UserRow = ({ withAction }: { withAction?: boolean }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <SkeletonBar width={34} height={5} />
    <SkeletonBar width="100%" height={5} sx={{ flexShrink: 1 }} />
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
      <BaseActions />
      {withAction && (
        <HighlightFrame sx={{ padding: '2px 4px', color: 'primary.main' }}>
          <TypeDocumentsIcon />
        </HighlightFrame>
      )}
    </Box>
  </Box>
);

const PermissionsDialog = () => (
  <Box
    sx={theme => ({
      display: 'flex',
      flexDirection: 'column',
      gap: 0.75,
      padding: 0.75,
      borderRadius: '6px',
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[2],
    })}
  >
    <Typography sx={{ fontSize: 9.5, fontWeight: 600, color: 'text.primary' }}>
      Permissões de Tipos de Documentos
    </Typography>
    {[0, 1, 2].map(line => (
      <Box key={line} sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
        <SkeletonBlock width={8} height={8} radius={2} />
        <SkeletonBar width={line === 1 ? '48%' : '66%'} height={5} />
      </Box>
    ))}
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 0.5 }}>
      <SkeletonBlock width={26} height={9} radius={3} />
      <SkeletonBlock width={26} height={9} radius={3} />
    </Box>
  </Box>
);

const Screen = ({ withAction }: { withAction?: boolean }) => (
  <CoachmarkCanvas>
    <SkeletonBar width={90} height={7} />
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      <UserRow withAction={withAction} />
      <UserRow withAction={withAction} />
    </Box>
    {withAction && <PermissionsDialog />}
  </CoachmarkCanvas>
);

export const useAccessUserTypeDocumentsStates: CoachmarkState[] = [
  { label: 'Marcado', preview: <Screen withAction /> },
  { label: 'Desmarcado', preview: <Screen /> },
];
